import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { GenericHttpService } from '../../shared/generic-http.service';
import { AreaParticipacaoModel } from '../model/area-participacao.model';
import { ConfiguracoesProjeto } from './../../shared/model/configuracoes-projeto.model';
import { ParametrosService } from './parametros.service';

@Injectable()
export class AreaParticipacaoService {
  public _urlBase: string;
  public configuracao: ConfiguracoesProjeto;

  public areasParticipacao: AreaParticipacaoModel[];
  public areasParticipacaoChange = new Subject<AreaParticipacaoModel[]>();
  public areasParticipacaoErro = '';

  constructor(
    private readonly genericHttpService: GenericHttpService<AreaParticipacaoModel>,
    private readonly parametrosService: ParametrosService
  ) {}

  get urlBase() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlBase = this.configuracao.uri + 'area-participacao/';

    return this._urlBase;
  }

  getAreasParticipacao() {
    const api = `listagem`;

    this.genericHttpService.getById(this.urlBase + api).subscribe(
      (data: any) => {
        this.areasParticipacao = <AreaParticipacaoModel[]>data;
        this.areasParticipacaoErro = '';
        this.areasParticipacaoChange.next(this.areasParticipacao.slice());
      },
      (error: any) => {
        this.areasParticipacao = [];
        this.areasParticipacaoErro = error;
        this.areasParticipacaoChange.next(this.areasParticipacao.slice());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/area-participacao.service.ts